import checkIfGearHasProp from '@/utils/checkIfGearHasProp'
import {WEAPON_RANGE} from '@/constants/weaponPropList'

const checkHasRange = checkIfGearHasProp(WEAPON_RANGE)

export default checkHasRange
